import React, { useEffect, useState } from 'react';
import GracePeriodApi from '../../api/GracePeriodApi';
import { handleUnauthorizedResponse } from '../../api/http';
import { AuthData } from '../../context/auth';
import { ErrorData } from '../../context/ErrorProvider';
import { PolicyData, withPolicyContext } from '../../context/policy';
import { GRACE_PERIOD_TABLE_LABEL } from '../../data/labelsAndMessages';
import { GracePeriodResponse } from '../../types/policy';
import {
	StyledSectionContainer,
	StyledTitle,
	StyledTitleContainer,
} from '../common';
import GracePeriodTable from './GracePeriodTable';

interface Props {
	policyData: PolicyData;
	authData: AuthData;
	errorData: ErrorData;
}

/**
 * The list of grace periods for a policy.
 */
const GracePeriods = ({
	authData,
	errorData,
	policyData: { policy },
}: Props) => {
	const [gracePeriods, setGracePeriods] = useState<GracePeriodResponse[]>([]);

	useEffect(() => {
		(async () => {
			try {
				const response = await GracePeriodApi.getGracePeriods(
					authData.auth.authorizationToken,
					policy.locator,
				);
				setGracePeriods(response.data);
			} catch (error) {
				errorData.handleErrorResponse(error, 'Failed to fetch grace periods');
				handleUnauthorizedResponse(error, authData);
			}
		})();
	}, [policy]);

	return (
		<>
			<StyledTitleContainer>
				<StyledTitle>{GRACE_PERIOD_TABLE_LABEL()}</StyledTitle>
			</StyledTitleContainer>
			<hr />
			<StyledSectionContainer>
				<GracePeriodTable gracePeriods={gracePeriods} policy={policy} />
			</StyledSectionContainer>
		</>
	);
};

export default withPolicyContext<Props>(GracePeriods);
